var _g;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgCloseCircle(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 43,
    height: 43,
    viewBox: "0 0 43 43",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "close-circle"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Vector",
    d: "M21.5 4.03125C11.8678 4.03125 4.03125 11.8678 4.03125 21.5C4.03125 31.1322 11.8678 38.9688 21.5 38.9688C31.1322 38.9688 38.9688 31.1322 38.9688 21.5C38.9688 11.8678 31.1322 4.03125 21.5 4.03125ZM27.8249 25.9251C27.9549 26.0487 28.0589 26.197 28.1307 26.3614C28.2025 26.5257 28.2407 26.7028 28.243 26.8821C28.2453 27.0615 28.2116 27.2395 28.1441 27.4056C28.0765 27.5717 27.9763 27.7227 27.8495 27.8495C27.7227 27.9763 27.5717 28.0765 27.4056 28.1441C27.2395 28.2116 27.0615 28.2453 26.8821 28.243C26.7028 28.2407 26.5257 28.2025 26.3614 28.1307C26.197 28.0589 26.0487 27.9549 25.9251 27.8249L21.5 23.4006L17.0749 27.8249C16.8208 28.0662 16.4825 28.1988 16.1321 28.1943C15.7817 28.1898 15.4469 28.0486 15.1992 27.8008C14.9514 27.5531 14.8102 27.2183 14.8057 26.8679C14.8012 26.5175 14.9338 26.1792 15.1751 25.9251L19.5994 21.5L15.1751 17.0749C14.9338 16.8208 14.8012 16.4825 14.8057 16.1321C14.8102 15.7817 14.9514 15.4469 15.1992 15.1992C15.4469 14.9514 15.7817 14.8102 16.1321 14.8057C16.4825 14.8012 16.8208 14.9338 17.0749 15.1751L21.5 19.5994L25.9251 15.1751C26.1792 14.9338 26.5175 14.8012 26.8679 14.8057C27.2183 14.8102 27.5531 14.9514 27.8008 15.1992C28.0486 15.4469 28.1898 15.7817 28.1943 16.1321C28.1988 16.4825 28.0662 16.8208 27.8249 17.0749L23.4006 21.5L27.8249 25.9251Z",
    fill: "red"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgCloseCircle);
export default __webpack_public_path__ + "static/media/close-circle.51a1b7c0f95822558b2407aeeffd5367.svg";
export { ForwardRef as ReactComponent };